import {produce} from 'immer';
import {useAtomCallback} from 'jotai/utils';
import {useState} from 'react';
import styled from 'styled-components';
import {ToggleSwitch} from '@/components/ToggleSwitch';
import {useGA4WithParams} from '@/hooks/tracking';
import {AnalysisItem} from '@/map/@types';
import {anaysisListAtom} from '@/map/atom';
import {Divider, FlexFullGrow} from '@/styled-components';
import {palette} from '@/styles';
import {SectionInfoIcon, SectionTitle} from '../StyledComponents';
import {InfoWindow} from './InfoWindow';

interface IProps {
  item: AnalysisItem;
}

export const DeliveryTileToggle = ({item}: IProps) => {
  const [openInfo, setOpenInfo] = useState<boolean>(false);

  const showMyblock = item.delivery?.showTile;
  const tracking = useGA4WithParams();

  const toggleShow = useAtomCallback((get, set) => {
    if (!showMyblock) {
      tracking('analysis_delivery');
    }

    const list = get(anaysisListAtom);

    const nextList = produce(list, (draft) => {
      const idx = draft.findIndex((i) => i.id === item.id);

      if (idx >= 0) {
        if (draft[idx].delivery) {
          const nextState = !draft[idx].delivery?.showTile;

          draft[idx].delivery = {
            ...draft[idx].delivery,
            showTile: nextState,
          };

          if (!draft[idx].footTraffic) {
            return;
          }

          const footTrafficData = draft[idx].footTraffic as any;

          if (nextState) {
            if (footTrafficData?.showTile) {
              (draft[idx].footTraffic as any).showTile = false;
            }
          } else {
            if (
              draft[idx].footTraffic?.vars &&
              Object.keys(footTrafficData.vars).length
            ) {
              (draft[idx].footTraffic as any).showTile = true;
            }
          }
        } else {
          draft[idx].delivery = {
            showTile: true,
          };

          if (draft[idx].footTraffic?.showTile) {
            (draft[idx].footTraffic as any).showTile = false;
          }
        }
      }
    });

    set(anaysisListAtom, nextList);
  });

  return (
    <Root>
      <SectionTitle>
        배달 비중
        <SectionInfoIcon onClick={() => setOpenInfo(true)} />
        <FlexFullGrow />
        <ToggleSwitch
          variant="small"
          bgColor={palette.gray300}
          checked={showMyblock}
          onChange={toggleShow}
        />
      </SectionTitle>
      <Divider />
      {openInfo && (
        <InfoWindow type="tile" onClose={() => setOpenInfo(false)} />
      )}
    </Root>
  );
};

const Root = styled.div``;
